import { render, staticRenderFns } from "./VModalAlert.vue?vue&type=template&id=71b35eca&"
import script from "./VModalAlert.vue?vue&type=script&lang=ts&"
export * from "./VModalAlert.vue?vue&type=script&lang=ts&"
import style0 from "./VModalAlert.vue?vue&type=style&index=0&id=71b35eca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports